import * as React from "react";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import * as types from "../../constants/actionTypes";
import Cookies from "cookies-js";
import * as tools from "../../helpers/Tools";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class RefreshOnNav extends React.Component {

    componentDidUpdate(prevProps) {
        if (prevProps.currentRoute !== this.props.currentRoute) {
            this.forceUpdate();
        }
    }

    render() {
        return (
            <div>
                <script>
                    var sRoute = "{this.props.currentRoute}";
                </script>
                {this.props.children}
            </div>);
    }

}

function mapStateToProps(state, ownProps) {
    //debugger;
    var oProps = {
        isLoggedIn: state.domain.li,
        currentRoute: ownProps.location.pathname
    };

    return oProps;
}

const mapDispatchToProps = (dispatch) => {
    return {
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RefreshOnNav));